import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { StoreHost } from './hosts/storeHost/StoreHost';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
    document.getElementById('ai-app') as HTMLElement,
);
root.render(
    <React.StrictMode>
        <StoreHost />
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
